var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-drawer",
    {
      staticClass: "org_auth",
      attrs: {
        title: _vm.textMap[_vm.addOrEditData.status],
        visible: _vm.addOrEditData.visible,
        "destroy-on-close": false,
      },
      on: {
        "update:visible": function ($event) {
          return _vm.$set(_vm.addOrEditData, "visible", $event)
        },
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "dataForm",
          attrs: {
            rules: _vm.rules,
            model: _vm.orgGroupData,
            "label-width": "90px",
          },
        },
        [
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.addOrEditData.status === "update",
                  expression: "addOrEditData.status === 'update'",
                },
              ],
              attrs: { label: "ID" },
            },
            [
              _c("el-input", {
                model: {
                  value: _vm.orgGroupData.orgGroupId,
                  callback: function ($$v) {
                    _vm.$set(_vm.orgGroupData, "orgGroupId", $$v)
                  },
                  expression: "orgGroupData.orgGroupId",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              attrs: { label: _vm.$t("tableFrom.name"), prop: "orgGroupName" },
            },
            [
              _c("el-input", {
                model: {
                  value: _vm.orgGroupData.orgGroupName,
                  callback: function ($$v) {
                    _vm.$set(_vm.orgGroupData, "orgGroupName", $$v)
                  },
                  expression: "orgGroupData.orgGroupName ",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("tableFrom.identification"),
                prop: "orgGroupCode",
              },
            },
            [
              _c("el-input", {
                model: {
                  value: _vm.orgGroupData.orgGroupCode,
                  callback: function ($$v) {
                    _vm.$set(_vm.orgGroupData, "orgGroupCode", $$v)
                  },
                  expression: "orgGroupData.orgGroupCode",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "sw-drawer__footer" },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.addOrEditData.visible = false
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("buttons.Cancel")))]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "has",
                  rawName: "v-has",
                  value: "sysOrgGroup:update",
                  expression: "'sysOrgGroup:update'",
                },
              ],
              attrs: { type: "primary" },
              on: {
                click: function ($event) {
                  _vm.addOrEditData.status === "create"
                    ? _vm.createData()
                    : _vm.updateData()
                },
              },
            },
            [
              _vm._v(
                "\n        " + _vm._s(_vm.$t("buttons.Confirm")) + "\n      "
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }